<script setup lang="ts">
import type { PreparationOptionStoryblok } from "~/types/storyblok";
import { SwiperSlide } from "swiper/vue";

const props = defineProps<{
	blok: any;
}>();

const slideProgress = ref<{ value: number; total: number }[]>([]);

function calculateProgress(swiper: { virtualSize: number; size: number; translate: number }, index: number): void {
	slideProgress.value[index] = {
		total: swiper.virtualSize,
		value: swiper.size + -swiper.translate
	};
}

if (props.blok) {
	props.blok.preparationOptions?.forEach((option: PreparationOptionStoryblok) => {
		slideProgress.value.push({ value: 1, total: option.steps?.length || 4 });
	});
}
</script>
<template>
	<div class="flex flex-col gap-8">
		<div v-for="(option, index) in blok?.preparationOptions || []" :key="option._uid">
			<Typography v-if="option?.title" variant="h2" class="text-3xl font-brush">
				{{ option.title }}
			</Typography>
			<Typography v-if="option?.preparation_time" variant="p" class="font-normal italic">
				Bereidingstijd van {{ option.preparation_time }} minuten
			</Typography>
			<KippieCarousel
				:space="0"
				free-mode
				class="mt-4"
				@loaded="calculateProgress($event, index)"
				@slide-change="calculateProgress($event, index)"
				@resize="calculateProgress($event, index)"
			>
				<SwiperSlide v-for="step in option?.steps || []" :key="step._uid" class="max-w-[18.1875rem] pr-4">
					<div class="space-y-4">
						<NuxtImg
							class="w-full aspect-square rounded-xl object-cover"
							:src="step.image.filename"
							provider="storyblok"
							:alt="step.image.alt"
							sizes="xl:291px lg:291px md:291px sm:291px xs:291px"
						/>
						<div>
							<h4 class="text-xl font-bold">
								{{ step.title }}
							</h4>
							<span class="text-sm">
								{{ step.text }}
							</span>
						</div>
					</div>
				</SwiperSlide>
			</KippieCarousel>
			<KippieProgressBar
				v-if="option?.steps && option?.steps?.length > 4"
				:value="slideProgress[index].value"
				:total="slideProgress[index].total"
				variant
				class="my-4 last:mb-0"
			/>
		</div>
	</div>
</template>
